export default "__VITE_ASSET__Dqgjk9Fh__"